package com.kinoshazam.screens.search.host

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.kinoshazam.screens.search.compact.CompactSearchContent
import com.kinoshazam.screens.search.expanded.ExpandedSearchWindow
import com.kinoshazam.screens.search.medium.MediumSearchContent
import org.koin.compose.viewmodel.koinViewModel
import presentation.screens.search.SearchViewModel
import utils.FormFactor

@Composable
fun SearchContentHost(
    formFactor: FormFactor,
) {
    val viewModel = koinViewModel<SearchViewModel>()
    val state by viewModel.state.collectAsStateWithLifecycle()

    when (formFactor) {
        FormFactor.Compact -> CompactSearchContent(
            state = state,
            onAction = viewModel::onAction,
        )

        FormFactor.Medium, FormFactor.Expanded -> MediumSearchContent(
            state = state,
            onAction = viewModel::onAction,
        )

        FormFactor.ExtraLarge -> ExpandedSearchWindow(
            state = state,
            onAction = viewModel::onAction,
        )
    }
}